import PaymentMethodSelector from "./StripePayment";
import { loadStripe } from '@stripe/stripe-js';

import { Elements } from "@stripe/react-stripe-js";


function StripeHandler() {

    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string);


    return (
        <Elements stripe={stripePromise} >
            <PaymentMethodSelector />
        </Elements >
    );
}

export default StripeHandler;